import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

const ENTITY_CHANGE_EVENTS: Array<'created' | 'updated' | 'deleted'> = ['created', 'updated', 'deleted'];

/**
 * Fires whenever a Goal changes. Payload is entityId-only; callers refetch the
 * goal-backed query they render.
 */
export function useGoalDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.GOAL, () => onChange(), ENTITY_CHANGE_EVENTS);
}
